import { type DetailsPageProps } from 'app/main/components/page-layouts';

import DemsDetailsTab from './tabs/DemsDetailsTab';
import DemsRecipientsTab from './tabs/DemsRecipientsTab';
import DemsClicksTab from './tabs/DemsClicksTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <DemsDetailsTab {...props} />
	},
	{
		id: 'recipients',
		title: 'TAB_RECIPIENTS',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model }) => <DemsRecipientsTab model={model} />
	},
	{
		id: 'links',
		title: 'TAB_LINKS',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model }) => <DemsClicksTab demUid={model.dems_uid} />
	}
];

export default tabs;
